@if (editItem) {
  <div class="context-menu-container">
    <button class="menu-item" type="button" (click)="onClicked(editItem.commandId)"><i class="{{ editItem.icon }}"></i></button>
  </div>
}
@if (menuDefinition && menuDefinition.length > 0) {
  <div class="context-menu-container">
    <ul>
      @for (item of menuItems; track item) {
        <ng-container>
          <li>
            <button class="menu-item" type="button" (click)="onClicked(item.commandId)"><i class="{{ item.icon }}"></i></button>
          </li>
        </ng-container>
      }
    </ul>
  </div>
}
